import { Inter } from "next/font/google";

// A styled list class for prose elements, specifically for lists with bullet points from Tailwind CSS's Typography plugin.
// Apply to the `ul` element to ensure consistent styling across the application.
export const LIST =
  "list-disc pl-6 text-foreground [&>li]:text-foreground space-y-2 leading-7 marker:text-muted-foreground [&>li]:pl-1";

export const INTER_FONT = Inter({
  subsets: ["latin"],
  variable: "--font-inter",
});

export const PARAGRAPH = "text-base leading-relaxed my-5 first:mt-0 last:mb-0";

export const BLOCKQUOTE_CLASSES =
  "border-l-4 border-accent-foreground/40 pl-3 md:pl-4 italic text-foreground font-medium my-8 text-base/8 py-0.5";

export const BODY = `${INTER_FONT.variable} font-sans bg-background text-foreground antialiased selection:bg-ring selection:bg-opacity-70 selection:text-popover flex flex-col min-h-screen overflow-x-hidden relative scroll-smooth`;

export const MAIN_LAYOUT_CLASSES = "container pb-16 sm:pb-24";

// Sizes for cards, modals, etc.

// 🧱 Card padding utilities
export const CARD_PADDING = "p-6 md:p-8"; // 1.5rem → 2rem
export const SUBCARD_PADDING = "p-4 md:p-6"; // 1rem → 1.5rem
export const INNER_SUBCARD_PADDING = "p-1.5 md:p-4"; // 0.375rem → 1rem

// 🌀 Border radius
export const CARD_RADIUS = "rounded-2xl"; /* 1rem (16px) */
export const SUBCARD_RADIUS = "rounded-lg"; /* 0.5rem (8px) */
export const INNER_SUBCARD_RADIUS =
  "rounded-sm"; /* 0.25rem (4px) Useful for Visual Embed (like FAQ video or image) inside of a subcard */

// 🌑 Shadows
export const CARD_SHADOW = "shadow-md"; // subtle but elevated
export const SUBCARD_SHADOW = "shadow-xs"; // very subtle or none
export const INNER_SUBCARD_SHADOW = "shadow-none"; // Clean, flat embed

// Card border
export const CARD_BORDER = "border border-border-light";

// ---------- START of Spacing Constants ----------
// Note that the card spacing units are all using the same values for consistency, but if we ever need to change them, we need to update all of them together to maintain consistency.
export const PAGE_HEADING_BOTTOM_MARGIN = "mb-10 md:mb-12"; // Below page headings before content

// 📐 Spacing between cards
export const CARD_SPACING = "space-y-10 md:space-y-12"; // between standalone cards
export const SUBCARD_SPACING = "space-y-4 md:space-y-6"; // between subcards

// 📏 Vertical margin between cards/subcards (for elements like HorizontalRule). Based on the CARD_SPACING and SUBCARD_SPACING
export const CARD_MARGIN_Y = "my-10 md:my-12";
export const SUBCARD_MARGIN_Y = "my-4 md:my-6";

// 📐 Grid layout for subcards
export const CARD_GRID_GAP = "gap-10 md:gap-12";
export const SUBCARD_GRID_GAP = "gap-4 md:gap-6"; // Gap between cards in a grid layout
// ---------- END of Card Spacing Constants ----------

export const FOCUS_RING =
  "focus:outline-hidden focus-visible:ring-3 focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:ring-ring focus-visible:rounded-sm";

// Link styling classes
export const DEFAULT_LINK_CLASSES =
  "font-semibold break-words cursor-pointer hover:cursor-pointer";
export const LINK_BLUE_CLASSES =
  "text-link hover:text-link-hover group-hover:text-link-hover";
export const LINK_GRAY_CLASSES =
  "text-link-gray hover:text-link-gray-hover group-hover:text-link-gray-hover";
export const LINK_WHITE_CLASSES =
  "text-tertiary-foreground hover:text-tertiary-foreground/80 group-hover:text-tertiary-foreground/80";
export const LINK_UNDERLINE_CLASSES =
  "decoration-2 underline-offset-1 decoration-link/25 hover:decoration-link/60 group-hover:decoration-link/60 underline";

// Avoid hover and scaling on mobile touch devices
export const HOVER_SCALE_CLASSES =
  "group sm:transition-transform sm:duration-150 sm:hover:scale-[1.01] sm:active:scale-100";
